import React, {Component} from 'react'


class Register extends Component{
    
    render(){
        document.body.classList.remove('page-rooms')
        return (
            <div className="f">
                
            </div>
        )
    }
}

export default Register;